// extracted by mini-css-extract-plugin
export default {"button-group":"button-group_NCH7o","input-number":"input-number_m2DuR"};